//
// --- Types ---

export type CountryCodeKeyType = keyof typeof COUNTRY_CODE;
export type CountryCodeType = typeof COUNTRY_CODE[CountryCodeKeyType];

export type GeographicRegionPrefixKeyType = keyof typeof GEOGRAPHIC_REGION_PREFIX;
export type GeographicRegionPrefixType = typeof GEOGRAPHIC_REGION_PREFIX[GeographicRegionPrefixKeyType];

//
// --- Constants ---

export const COUNTRY_CODE = {
  UNITED_STATES: 'USA',
  CANADA: 'CAN'
} as const;

export const GEOGRAPHIC_REGION_PREFIX = {
  COUNTRY: 'C_',
  STATE: 'S_'
} as const;
